import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import {
  RecommendationItemType,
  RecommendationItem
} from '../../services/trigger-point-recommendations.model';


export interface ArticleInfo{
  id: string;
  context: string;
}

@Component({
  selector: 'app-recommendations-list',
  templateUrl: './recommendations-list.component.html',
  styleUrls: ['./recommendations-list.component.scss'],
})
export class RecommendationsListComponent {

  @Input() recommendations:Array<RecommendationItem> = [];
  @Input() context:string;
  @Output() openArticle:EventEmitter<ArticleInfo> = new EventEmitter();
  RecommendationItemType = RecommendationItemType;

  onOpenArticle(articleId:string): void {
    this.openArticle.next({
      id:articleId,
      context:this.context
    });
  }
}
